
<template>
    <c-dialog ref="dialog" title="修改售后位置" mode="slide" width="1000" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
        <c-form ref="form" vertical unit-width="100%" column="2">
            <c-title>基础信息</c-title>
            <!-- 只读信息展示 -->
            <c-form-item label="工单号">
                <c-input v-model="displayInfo.order_number" disabled></c-input>
            </c-form-item>
            <c-form-item label="客户名称">
                <c-input v-model="displayInfo.customer_name" disabled></c-input>
            </c-form-item>
            <c-form-item label="售后网点">
                <c-input v-model="displayInfo.after_sale_outlet_name" disabled></c-input>
            </c-form-item>
            <c-form-item label="预约日期">
                <c-input v-model="displayInfo.appointment_start_time" disabled></c-input>
            </c-form-item>
            <c-form-item label="预计服务时长">
                <c-input v-model="displayInfo.estimated_service_days" disabled append-text="天"></c-input>
            </c-form-item>
            <c-form-item label="预计住宿天数">
                <c-input v-model="displayInfo.accommodation_days" disabled append-text="晚"></c-input>
            </c-form-item>
            <c-form-item label="预计上门人数">
                <c-input v-model="displayInfo.estimated_technician_count" disabled append-text="人"></c-input>
            </c-form-item>
            <c-form-item label="是否使用机台">
                <c-input :value="useMachineLabel" disabled></c-input>
            </c-form-item>
            <c-form-item label="出行方式">
                <c-input :value="travelModeLabel" disabled></c-input>
            </c-form-item>

            <c-title>售后服务位置</c-title>

            <!-- 可编辑：客户服务地址 -->
            <c-form-item label="客户服务地址" required>
                <template #handle>
                    <c-link @click="openCustomerAddressSelector">选择客户地址</c-link>
                </template>
                <div class="customer-address-row">
                    <c-location lng-name="customer_address_longitude" lat-name="customer_address_latitude" address-name="customer_address_detail" @updateLngLat="val => endPoint = val"></c-location>
                </div>
            </c-form-item>

            <c-form-item label="距客户距离">
                <c-input :value="distanceDisplay" disabled></c-input>
                <template #tip>
                    <p v-if="customer_distance" style="color: #999;">{{customer_distance}}公里，{{distanceTipWord}}</p>
                </template>
            </c-form-item>
        </c-form>

        <!-- 预估成本展示 -->
        <dl class="expenses">
            <dt class="flex-between-center">
                <p>预估成本：</p>
                <strong>￥{{expensesDetail.estimated_cost_total || '-'}}</strong>
            </dt>
            <dd v-if="expensesDetail.estimated_cost_list.length">
                <ul>
                    <li v-for="(item, i) in expensesDetail.estimated_cost_list" :key="i" class="flex-between-center">
                        <span>{{item.fee_type_name}}：</span>
                        <span>￥{{item.amount}}</span>
                    </li>
                </ul>
            </dd>
        </dl>

        <customer-address-selector ref="customerAddressSelector" @confirm="onCustomerAddressPicked"></customer-address-selector>

        <template #button>
            <c-button size="form" @click="$refs.dialog.close()">取消</c-button>
            <c-button size="form" color="main" @click="handleSubmit">保存</c-button>
        </template>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';
import customerAddressSelector from '@/components/service/customer_address_selector.vue';

export default {
    name: 'aftersaleOrderEditLocation',

    components: {
        customerAddressSelector
    },

    data() {
        return {
            orderId: null,
            customerId: '',
            startPoint: '',
            endPoint: '',
            customer_distance: 0,
            customer_duration: 0,
            feeCalcData: {},

            displayInfo: {
                order_number: '',
                customer_name: '',
                after_sale_outlet_name: '',
                estimated_service_days: '',
                accommodation_days: '',
                estimated_technician_count: '',
                appointment_start_time: '',
                use_machine: '',
                travel_mode: ''
            },

            expensesDetail: {
                estimated_cost_total: '',
                estimated_cost_list: []
            }
        }
    },

    computed: {
        ...mapState(['userInfo', 'useMachineOptions', 'travelModeOptions']),

        distanceTipWord() {
            let sec = parseInt(this.customer_duration);
            let hours = sec / 3600;
            return '驾车预计耗时' + hours.toFixed(1) + '小时';
        },

        distanceDisplay() {
            return this.customer_distance ? this.customer_distance + ' km' : '-';
        },

        useMachineLabel() {
            let item = (this.useMachineOptions || []).find(o => o.value == this.displayInfo.use_machine);
            return item ? item.name : this.displayInfo.use_machine;
        },

        travelModeLabel() {
            let item = (this.travelModeOptions || []).find(o => o.value == this.displayInfo.travel_mode);
            return item ? item.name : this.displayInfo.travel_mode;
        }
    },

    watch: {
        startPoint() {
            this.getDistance();
        },

        endPoint() {
            this.getDistance();
        },

        customer_distance() {
            this.calculateExpenses();
        }
    },

    methods: {
        open(orderId) {
            this.orderId = orderId;
            this.customerId = '';
            this.startPoint = '';
            this.endPoint = '';
            this.customer_distance = 0;
            this.customer_duration = 0;
            this.feeCalcData = {};
            this.displayInfo = {
                order_number: '',
                customer_name: '',
                after_sale_outlet_name: '',
                estimated_service_days: '',
                accommodation_days: '',
                estimated_technician_count: '',
                appointment_start_time: '',
                use_machine: '',
                travel_mode: ''
            };
            this.expensesDetail = {
                estimated_cost_total: '',
                estimated_cost_list: []
            };
            this.$refs.form.clear();
            this.loadOrderDetail();
            this.$refs.dialog.open();
        },

        loadOrderDetail() {
            this.request({
                url: '/after/sale/order/detail',
                data: { id: this.orderId },
                success: ({detailInfo}) => {
                    this.displayInfo = {
                        order_number: detailInfo.order_number,
                        customer_name: detailInfo.customer_name,
                        after_sale_outlet_name: detailInfo.after_sale_outlet_name,
                        estimated_service_days: detailInfo.estimated_service_days,
                        accommodation_days: detailInfo.accommodation_days,
                        estimated_technician_count: detailInfo.estimated_technician_count,
                        appointment_start_time: detailInfo.appointment_start_time,
                        use_machine: detailInfo.use_machine,
                        travel_mode: detailInfo.travel_mode
                    };
                    this.customerId = detailInfo.customer_id || '';

                    // 回显地址信息
                    this.$refs.form.set({
                        customer_address_longitude: detailInfo.customer_address_longitude,
                        customer_address_latitude: detailInfo.customer_address_latitude,
                        customer_address_detail: detailInfo.customer_address_detail
                    });

                    // 设置网点起点（用于计算距离）
                    if (detailInfo.after_sale_outlet_longitude && detailInfo.after_sale_outlet_latitude) {
                        this.startPoint = `${detailInfo.after_sale_outlet_longitude},${detailInfo.after_sale_outlet_latitude}`;
                    }

                    // 回显已有距离
                    this.customer_distance = detailInfo.customer_distance || 0;
                    this.customer_duration = detailInfo.customer_duration || 0;

                    // 存储费用计算所需字段
                    this.feeCalcData = {
                        use_machine: detailInfo.use_machine,
                        travel_mode: detailInfo.travel_mode,
                        estimated_service_days: detailInfo.estimated_service_days,
                        estimated_technician_count: detailInfo.estimated_technician_count
                    };
                }
            });
        },

        getDistance() {
            if (!this.startPoint || !this.endPoint) {
                this.customer_distance = 0;
                this.customer_duration = 0;
            } else {
                this.request({
                    url: '/location/distance',
                    data: {
                        longitude1: this.startPoint.split(',')[0],
                        latitude1: this.startPoint.split(',')[1],
                        longitude2: this.endPoint.split(',')[0],
                        latitude2: this.endPoint.split(',')[1]
                    },
                    success: data => {
                        this.customer_distance = data.distance;
                        this.customer_duration = data.duration;
                    }
                });
            }
        },

        calculateExpenses() {
            this.expensesDetail = {
                estimated_cost_total: '',
                estimated_cost_list: []
            };

            this._expensesRequest && this._expensesRequest.abort();

            if (this.customer_distance) {
                this._expensesRequest = this.request({
                    url: '/after/sale/order/cal/fee',
                    data: Object.assign({}, this.feeCalcData, {
                        customer_distance: this.customer_distance
                    }),
                    success: data => {
                        this.expensesDetail = data;
                    }
                });
            }
        },

        openCustomerAddressSelector() {
            if (!this.customerId) {
                this.$message({
                    message: '当前工单未关联客户档案，无法选择常用地址',
                    type: 'warning'
                });
                return;
            }
            this.$refs.customerAddressSelector.open(this.customerId);
        },

        onCustomerAddressPicked(data) {
            this.$refs.form.set({
                customer_address_longitude: data.longitude,
                customer_address_latitude: data.latitude,
                customer_address_detail: data.address_detail || ''
            });
        },

        handleSubmit() {
            this.$refs.form.submit({
                url: '/after/sale/order/edit/location',
                rule: {
                    customer_address_longitude: '请选择客户服务地址',
                    customer_address_latitude: '请选择客户服务地址',
                    customer_address_detail: '请填写客户详细地址'
                },
                dataFormatter: data => {
                    return {
                        id: this.orderId,
                        customer_address_longitude: data.customer_address_longitude,
                        customer_address_latitude: data.customer_address_latitude,
                        customer_address_detail: data.customer_address_detail,
                        customer_distance: this.customer_distance || 0
                    };
                },
                success: () => {
                    this.$message({
                        message: '修改售后位置成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.customer-address-row
    width 100%
    .c-button
        margin-bottom 8px

.expenses {
    width: 100%;
    border-radius: 8px;
    padding: 0 20px;
    margin-top: 10px;
    background: #F9F9F9;
    box-sizing: border-box;

    dt {
        height: 50px;

        p {
            font-size: 16px;
            font-weight: bold;
        }

        strong {
            font-size: 18px;
            color: #FF0000;
        }
    }

    dd {
        padding-bottom: 15px;

        ul {
            padding-left: 0;
        }

        li {
            height: 24px;
            font-size: 13px;
            color: #999;
        }
    }
}
</style>
